// 群发送消息记录表
import { DB, ExecuteResult, QueryResult } from './index';
import time from '../time';

export type GroupSendMsg = {
    tid: string; // 群ID（主键）
    uid: number; // 用户ID
    time: number; // 发送时间
};

// 获取群发送消息记录
export async function group_send_msg_get(
    db: DB,
    tid: string,
): Promise<{ error?: any; data?: GroupSendMsg }> {
    const r = await db.Query(
        `SELECT tid, uid, time FROM t_group_send_msg WHERE tid = ?`,
        [tid],
    );

    if (r.error) {
        return { error: r.error };
    }

    if (r.data && r.data.length > 0) {
        const row = r.data[0];
        return {
            data: {
                tid: row.tid,
                uid: row.uid,
                time: row.time,
            },
        };
    }

    return {};
}

// 设置群发送消息记录（插入或更新）
export async function group_send_msg_set(
    db: DB,
    msg: GroupSendMsg,
): Promise<ExecuteResult> {
    const sql = `
        INSERT INTO t_group_send_msg (tid, uid, time)
        VALUES (?, ?, ?)
        ON CONFLICT(tid)
        DO UPDATE SET uid = ?, time = ?
    `;

    const params = [msg.tid, msg.uid, msg.time, msg.uid, msg.time];

    const r = await db.Execute(sql, params);
    return r;
}

// 删除群发送消息记录
export async function group_send_msg_delete(
    db: DB,
    tid: string,
): Promise<ExecuteResult> {
    const sql = `DELETE FROM t_group_send_msg WHERE tid = ?`;
    const r = await db.Execute(sql, [tid]);
    return r;
}

// 查询指定用户和群的消息记录
export async function group_send_msg_query(
    db: DB,
    uid: number,
    tid: string,
): Promise<{ error?: any; data?: GroupSendMsg[] }> {
    const r = await db.Query(
        `SELECT tid, uid, time FROM t_group_send_msg WHERE uid = ? AND tid = ?`,
        [uid, tid],
    );

    if (r.error) {
        return { error: r.error };
    }

    if (r.data && r.data.length > 0) {
        const results: GroupSendMsg[] = r.data.map((row: any) => ({
            tid: row.tid,
            uid: row.uid,
            time: row.time,
        }));
        return { data: results };
    }

    return { data: [] };
}
